// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"60851dea","334":"4f17e636","621":"6876187e","698":"ed39fe96","979":"81e37fd3"}[chunkId] + ".chunk.js";
};